module.exports = __webpack_public_path__ + "static/media/lagalaxy.8d2ca1e9.png";